<template>
  <page>
    <module enable-flex>
      <m-search ref="search" @search="searchHandle">
        <c-form ref="searchForm">
	      <c-form-item type="input" label="会员昵称" name="nick_name">
	      </c-form-item>
	      <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone">
	      </c-form-item>
          <c-form-item type="input" label="邀请人手机" name="share_user_manage_mobilephone">
          </c-form-item>
          <c-form-item type="select" label="会员等级" name="user_level" options="USER_LEVEL_AUTH">
          </c-form-item>
          <c-form-item type="checkbox" label="用户状态" name="state" :options="stateType" :value="[1]">
          </c-form-item>
          <!-- <c-form-item type="checkbox" label="推客状态" name="tk_bind_states" :options="bindingState">
          </c-form-item> -->
        </c-form>
      </m-search>
      <m-operate v-show="higherLevel.platform_user_id">
        <c-button color="black" hollow @click="backHigher">
          返回
        </c-button>
        <span v-if="higherLevel.platform_user_id" style="margin-left: 10px; font-size: 13px;">
					上级：{{`${higherLevel.nick_name}(${higherLevel.user_manage_mobilephone})`}}
				</span>
      </m-operate>
      <c-table ref="table">
        <c-table-column label="会员昵称" name="nick_name" width="200">
          <template v-slot="{data}">
            <div class="flex-center-cross">
              <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
              <span>
								{{data.nick_name}}
							</span>
            </div>
          </template>
        </c-table-column>
        <c-table-column label="会员手机号" name="user_manage_mobilephone" width="120">
          <template v-slot="{data}">
            <a v-if="data.user_level > -99 && data.direct_count > 0" class="s-link"
               @click="loadLower(data)">
              ↓ {{data.user_manage_mobilephone}}
            </a>
            <span v-else-if="data.user_manage_mobilephone">
				{{data.user_manage_mobilephone}}
			</span>
            <span v-else>
				--
			</span>
          </template>
        </c-table-column>
		<c-table-column label="会员等级" name="user_level_name" width="90">
			<template v-slot="{data}">
			   <span v-if="data.platform_user_id==-99">-</span>
			   <span v-else>{{data.user_level_name}}</span>
			</template>
        </c-table-column>
		
		<c-table-column label="门店拓展佣金比例" name="mdtz_ratio" width="130">
		  <template v-slot="{data}">
		    <span v-if="data.user_level == 3"><a class="s-link" @click="setMdtzRatio(data)">{{parseFloat(data.mdtz_ratio||0)*100}}%</a></span>
		    <span v-else>-</span>
		  </template>
		</c-table-column>
		
        <c-table-column label="邀请人" name="share_user_manage_mobilephone" width="230">
          <template v-slot="{data}">
			  <span v-if="data.platform_user_id==-1">-</span>
             <span v-else>{{data.share_user_nick_name||'-'}}【<font color="#999">{{data.share_user_manage_mobilephone||'-'}}</font>】</span>
          </template>
        <!-- <c-table-column label="邀请人昵称" name="share_user_nick_name" width="120">
          <template v-slot="{data}">
            {{data.share_user_nick_name||'--'}}
          </template>
        </c-table-column> -->
        </c-table-column>
        <c-table-column label="邀请会员数" name="direct_count" width="90">
          <template v-slot="{data}">
            <a v-if="data.user_level >-99 && data.direct_count > 0" class="s-link"
               @click="loadLower(data)">
              &nbsp;↓&nbsp; {{data.direct_count}}
            </a>
            <span v-else>
							{{data.direct_count}}
						</span>
          </template>
        </c-table-column>
        <!-- <c-table-column label="间推会员" name="indirect_count" width="70">
        </c-table-column> -->
        <c-table-column label="状态" name="state" width="60">
          <template v-slot="{data}">
            <span v-if="data.state == 2" style="color:red">禁用</span>
            <span v-if="data.state == 1" style="color:green">启用</span>
          </template>
        </c-table-column>
		
		<c-table-column
			label="货款余额(元)"
			name="account_balance"
			width="100"
		>
			<template v-slot="{data}">
				￥{{data.account_balance}}
			</template>
		</c-table-column>
		
        <c-table-column label="收益余额(元)" name="account" width="100">
          <template v-slot="{data}">
            ￥{{(data.reward_balance||0).toFixed(2)}}
          </template>
        </c-table-column>
		
		<c-table-column label="积分余额" name="account" width="80">
			<template v-slot="{data}">
				{{(data.jf_balance||0).toFixed(2)}}
			</template>
		</c-table-column>

        <c-table-column label="加入会员时间" name="upgrade_date" width="150"></c-table-column>
        <!-- <c-table-column label="推客状态" name="sharer_appid" width="80">
            <template v-slot="{data}">
                <span v-if="data.sharer_appid" style="color: green">
                    已绑定
                </span>
                <span v-else style="color: red">未绑定</span>
            </template>
        </c-table-column> -->
		
		<c-table-column label="订单审核" name="auto_audit_sub_order" width="80">
		    <template v-slot="{data}">
		        <span v-if="data.auto_audit_sub_order == 1" style="color: red">
		            手动
		        </span>
		        <span v-if="data.auto_audit_sub_order == 2" style="color: green">自动</span>
		    </template>
		</c-table-column>
        <c-table-column label="绑定时间" name="upgrade_date" width="150">
            <template v-slot="{data}">
                <span v-if="data.sharer_bind_date">
                    {{data.sharer_bind_date}}
                </span>
                <span v-else>-</span>
            </template>
        </c-table-column>

        <c-table-column type="button" fixed="right" label="操作" width="200">
          <template v-slot="{data}">
<!--            <c-table-button power="b_member_user_view" @click="detail(data)" v-if="data.platform_user_id > 0">详情</c-table-button>-->
            <c-table-button power="b_member_user_view_symx" @click="viewReward(data)"> 收益明细 </c-table-button>
            <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="setMember(data)">会员调整</c-table-button>
          </template>
        </c-table-column>
      </c-table>
    </module>
    <c-dialog ref="rewardDialog" title="收益明细" width="1200" height="800" enable-flex :button="false">
      <m-search ref="rewardSearch" @search="rewardSearchHandle">
        <c-form ref="form" inline>
         <!-- <c-form-item type="checkbox" label="收益类型" name="reward_type" :options="rewardType">
          </c-form-item> -->
          <c-form-item type="checkbox" label="状态" name="state" :options="rewardState">
          </c-form-item>
          <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date">
          </c-form-item>
        </c-form>
      </m-search>
      <c-table ref="rewardTable" height="grow">
        <c-table-column label="单号" width="150" name="record_number">
        </c-table-column>
        <c-table-column label="收益类型" width="100" name="reward_type" v-if="false">
			<template v-slot="{data}">
				<span v-if="data.reward_type==1">零售收益</span>
				<span v-if="data.reward_type==2">分享补贴</span>
				<span v-if="data.reward_type==3">辅助分享补贴</span>
				<!-- <span v-if="data.reward_type==4">下单奖励</span> -->
				<!-- <span v-if="data.reward_type==5">辅助下单奖励</span> -->
				<span v-if="data.reward_type==6">解冻金额</span>
				<!-- <span v-if="data.reward_type==7">进货补贴</span> -->
				<!-- <span v-if="data.reward_type==8">辅助进货补贴</span> -->
				<span v-if="data.reward_type==9">区代奖励</span>
				<span v-if="data.reward_type==10">销售奖励</span>
				<span v-if="data.reward_type==11">分红奖励</span>
          </template>
        </c-table-column>
        <c-table-column label="收益金额" name="record_money" width="120">
          <template v-slot="{data}">
            <span v-if="data.state==0">￥{{(data.estimated_record_money||0).toFixed(2)}}</span>
            <span v-if="data.state==1"><span style="color:darkgray">[预估]</span>￥{{(data.estimated_record_money||0).toFixed(2)}}</span>
            <span v-if="data.state==2">￥{{(data.record_money||0).toFixed(2)}}</span>
          </template>
        </c-table-column>
        <c-table-column label="收益状态" name="state" width="75">
          <template v-slot="{data}">
				<span v-if="data.state==0" style="color:#aaaaaa">{{rewardStateMap[data.state]}}</span>
				<span v-if="data.state==1" style="color:sandybrown">{{rewardStateMap[data.state]}}</span>
				<span v-if="data.state==2" style="color:darkgreen">{{rewardStateMap[data.state]}}</span>
          </template>
        </c-table-column>
        <c-table-column label="关联用户" name="nick_name" width="250">
          <template v-slot="{data}">
            {{data.nick_name}}【<font color="#999">{{data.user_manage_mobilephone||'-'}}</font>】
          </template>
        </c-table-column>
        <!-- <c-table-column label="关联等级" name="level_name" width="80">
          <template v-slot="{data}">
				<span v-if="data.reward_type == 1 || data.reward_type == 2 || data.reward_type == 3 || data.reward_type == 6 || data.reward_type == 7 || data.reward_type == 8">{{data.level_name}}</span>
				<span v-else>-</span>
          </template>
        </c-table-column> -->
        <c-table-column label="关联单号" name="relate_number" width="150">
        </c-table-column>
		<!-- <c-table-column label="供货单号" name="relate_number" width="150">
			<template v-slot="{data}">
				<span v-if="data.reward_type == 1 || data.reward_type == 6">{{data.sub_order_number}}</span>
				<span v-else>-</span>
			</template>
		</c-table-column> -->
       <!-- <c-table-column label="商品原价" name="original_product_money" width="95">
          <template v-slot="{data}">
						<span v-if="data.reward_type == 1 || data.reward_type == 5">
              ￥{{(data.original_product_money||0).toFixed(2)}}
						</span>
            <span v-else>
							--
						</span>
          </template>
        </c-table-column> -->
        <c-table-column label="交易金额" name="product_money" width="95">
          <template v-slot="{data}">
						<span v-if="data.reward_type < 10">
							￥{{(data.product_money||0).toFixed(2)}}
						</span>
                        <span v-else>-</span>
          </template>
        </c-table-column>
        <c-table-column label="收益时间" name="create_date" width="155">
        </c-table-column>
        <c-table-column label="到账时间" name="settlement_date" width="155">
          <template v-slot="{data}">
            {{data.settlement_date||'-'}}
          </template>
        </c-table-column>
        <c-table-column label="备注" name="remark" width="350">
          <template v-slot="{data}">
            {{data.remark||'-'}}
          </template>
        </c-table-column>
      </c-table>
    </c-dialog>
    <c-dialog ref="memberDialog" title="调整会员邀请人/等级" width="660" height="860" @resolve="setMemberHandle">
		<c-form ref="memberForm">
			<c-form-item type="input" label="当前用户信息:" name="curr_user_info" disabled> </c-form-item>
			<c-form ref="shareForm" title="调整邀请人" title-margin="10">
				<c-form-item type="input" label="当前邀请人:" name="share_user_name" disabled> </c-form-item>
				<c-form-item type="hidden" name="share_user_id"></c-form-item>
				<c-form-item type="input" @click="$refs.memberUserSelector.open()" readonly label="修改为:" name="tran_share_user_name" required word="调整后该用户后续带来的收益奖归于新的邀请人下"></c-form-item>
			</c-form>
			<c-form title="调整等级" title-margin="10">
				<c-form-item type="input" label="当前等级:" name="user_level_name" disabled></c-form-item>
				<c-form-item type="select" label="调整为:" v-model="user_level" name="user_level" options="USER_LEVEL_AUTH" required></c-form-item>
			</c-form>
			<c-form ref="serviceCenterForm" title="门店信息" v-show="user_level == 2">
				<c-form-item type="input" label="门店名称" name="center_name" required></c-form-item>
				<c-form-item type="input" label="门店联系人" name="contacts" required></c-form-item>
				<c-form-item type="input" label="门店联系电话" name="phone_number" required> </c-form-item>
				<c-form-item type="region" label="门店地址"  province-name="province_id" city-name="city_id"  county-name="county_id" required></c-form-item>
				<c-form-item type="input" label="详细地址" name="address" required></c-form-item>
			</c-form>
		</c-form>
    </c-dialog>
	<c-dialog ref="mdtzRatioEdit" title="门店拓展佣金比例设置" width="400" @resolve="submitMdtzRatio">
		<c-form ref="mdtzRatioForm">
			<c-form-item type="number" decimal="2" label="佣金比例" name="mdtz_ratio" required :limit="[3,50]" input-unit="%"></c-form-item>
			<c-form-item type="hidden" name="member_user_id"></c-form-item>
		</c-form>
	</c-dialog>
    <member-user-selector ref="memberUserSelector" @resolve="selectHandle($event, 'memberList', 'platform_user_id')"></member-user-selector>
  </page>
</template>
<script>
import memberUserSelector from '@/components/service/member_user_selector.vue'
export
default {
  name: 'm_member_user',

  components: {
    memberUserSelector
  },

  data() {
    return {
      rewardState: [{
        name: '已取消',
        value: 0
      }, {
        name: '待到账',
        value: 1
      }, {
        name: '已到账',
        value: 2
      }],
      rewardStateMap: {
        '0': '已取消',
        '1': '待到账',
        '2': '已到账'
      },
      rewardType: [{
			name: '零售收益',
			value: 1
		  }, {
			name: '分享补贴',
			value: 2
		  }, {
		    name: '辅助分享补贴',
		    value: 3
		 //  }, {
			// name: '下单奖励',
			// value: 4
		 //  }, {
			// name: '辅助下单奖励',
			// value: 5
		  }, {
			name: '解冻金额',
			value: 6
		 //  }, {
			// name: '进货补贴',
			// value: 7
		 //  }, {
		 //    name: '辅助进货补贴',
		 //    value: 8,
		  }, {
			name: '区代奖励',
			value: 9,
		  }, {
			name: '销售奖励',
			value: 10,
		  }, {
			name: '分红奖励',
			value: 11,
		  }],
		  stateType: [
            {name: '启用',value: 1},
            {name: '禁用',value: 2}
          ],
          bindingState: [
            {name: '已绑定',value: 1},
            {name: '未绑定',value: 2}
          ],

          levelList: [],
          levelParams: {},
          member_user_id: '',
          recommend_type: '',
		  user_level: -99
    }
  },

  computed: {
	    higherLevel() {
	        return this.levelList[this.levelList.length - 1] || {};
	    }
  },

  watch: {
	higherLevel(val) {
		this.$refs.search.clear();
		let id = val.platform_user_id || 0;
		this.levelParams[id] && this.levelParams[id].searchParams && this.$refs.searchForm.set(this.levelParams[id].searchParams);
		this.$nextTick(() => {
			this.$refs.search.search(this.levelParams[id] ? this.levelParams[id].pageIndex : 1)
		})
	},
	
	user_level(val){
		//如果新数据为门店
		if(val == 2){
			this.queryUserShop();
		}
	}
  },

  mounted() {
    this.$refs.search.search();
  },

  methods: {
    selectHandle(list, ref, key) {
      var tran_share_user_name = "--";
      var share_user_id = -1;
      if (list && list[0]){
        console.log(list[0]);
        tran_share_user_name = (list[0].nick_name || "--") + "【" + list[0].user_manage_mobilephone||"--" + "】";
        share_user_id = list[0].platform_user_id||-1;
      }
      this.$refs.shareForm.set({
        tran_share_user_name: tran_share_user_name,
        share_user_id: share_user_id,
      });
    },

    setMemberHandle(stop) {
      stop();
      this.$refs.memberForm.submit({
        url: '/member_user/adjustment',
        rule: {
			share_user_id: '请设置邀请人',
			user_level: '请设置等级',
			
			center_name: [{
			    type: 'empty',
			    skip: () => {
			        return this.user_level != 2;
			    },
			    word: '请填写门店名称'
			}],
			contacts: [{
			    type: 'empty',
			    skip: () => {
			        return this.user_level != 2;
			    },
			    word: '请填写门店联系人'
			}],
			phone_number: [{
			    type: 'empty',
			    skip: () => {
			        return this.user_level != 2;
			    },
			    word: '请填写门店联系电话'
			}],
			province: [{
			    type: 'function',
			    fun: (v , data) => {
			        if(this.user_level == 2 && !data.county_id){
						return false;
					}else{
						return true;
					}
			    },
			    word: '请选择门店地址'
			}],
			address: [{
			    type: 'empty',
			    skip: () => {
			        return this.user_level != 2;
			    },
			    word: '请填写门店详细地址'
			}]
        },
        dataFormatter: data => {
          data.member_user_id = this._edit.platform_user_id;
          delete data.tran_share_user_name;
          return data;
        },

        success: data => {
          this.$refs.memberDialog.close();
          this.$message({
            text: '请求发送成功，调整结果可能稍有延迟!'
          });
          //延迟500ms刷新页面
          setTimeout(() => {
            this.$refs.table.update();
          }, 1000);
        }
      })
    },

    setMember(data) {
		this.$refs.memberForm.clear();
		this._edit = data;
		this.$refs.memberForm.set({
			curr_user_info: (data.nick_name || "") + "【" + (data.user_manage_mobilephone||'-') + "】",
			share_user_name: (data.share_user_nick_name || "") + "【" + (data.share_user_manage_mobilephone||'-') + "】",
			tran_share_user_name: (data.share_user_nick_name || "") + "【" + (data.share_user_manage_mobilephone||'-') + "】",
			user_level_name: data.user_level_name||'普通用户',
			share_user_id: data.share_user_id,
			user_level: data.user_level>0?data.user_level:-99,
			nick_name: data.nick_name,
			user_manage_mobilephone: data.user_manage_mobilephone
		});
		this.$refs.memberDialog.open();
    },

    viewReward(val) {
      this.$refs.rewardDialog.open();
      this.member_user_id = val.platform_user_id;
      this.$refs.rewardTable.load({
        url: '/member_user/reward/list',
        data: {
          member_user_id: val.platform_user_id,
        }
      });
    },

    rewardSearchHandle(data) {
      data.member_user_id = this.member_user_id;
      this.$refs.rewardTable.load({
        url: '/member_user/reward/list',
        data
      });
    },

    searchHandle(data = {}, page) {
	      data.member_user_id = this.higherLevel.platform_user_id;
	      this.$refs.table.load({
	        url: '/member_user/list',
	        data
	      }, page);
    },

    detail(val) {
      this.navigateTo({
        path: '/member/' + val.platform_user_id,
      });
    },

    loadLower(data) {
	  this.levelParams[this.higherLevel.platform_user_id || 0] = {
		  searchParams: this.$refs.search.get(),
		  pageIndex: this.$refs.table.pageIndex
	  }
      this.levelList.push(data);
    },

    backHigher() {
		delete this.levelParams[this.higherLevel.platform_user_id];
	    this.levelList.splice(this.levelList.length - 1, 1);
    },
	
	//查询用户门店信息
	queryUserShop(){
		this.request({
		    url: '/service_center/detail',
		    data: {
		        user_id: this._edit.platform_user_id
		    },
		    success: data => {
				if(data){
					this.$refs.serviceCenterForm.set(data);
				}
		    }
		});
	},
	
	//设置门店拓展佣金比例（弹框）
	setMdtzRatio(val) {
		this.$refs.mdtzRatioForm.clear();
		var tempUser = {};
		tempUser.mdtz_ratio = parseFloat(val.mdtz_ratio||0)*100;
		tempUser.member_user_id = val.platform_user_id;
		this.$refs.mdtzRatioForm.set(tempUser);
		this.$refs.mdtzRatioEdit.open();
	},
	
	//设置门店拓展佣金比例（提交）
	submitMdtzRatio(stop) {
	  stop();
	  this.$refs.mdtzRatioForm.submit({
	    url: '/member_user/mdtzRatio',
	    rule: {
	      mdtz_ratio: '请填写门店拓展佣金比例'
	    },
	    dataFormatter: data => {
			data.mdtz_ratio = parseFloat(data.mdtz_ratio)/100;
	      return data;
	    },
	    success: (data, res) => {
	      this.$message({
	        text: '保存成功'
	      });
	      this.$refs.table.update();
	      this.$refs.mdtzRatioEdit.close();
	    }
	  });
	},
  }
}
</script>